import { combineReducers } from 'redux';
import avatarSource from './avatarSource';
import checkUserName from './checkUserName';

export default combineReducers({
  avatarSource,
  checkUserName,
});
